// selectedRowSlice.js
import { createSlice } from '@reduxjs/toolkit';

const selectedJobCardSlice = createSlice({
    name: 'selectedCard',
    initialState: { selectedCard: null },
    reducers: {
        setSelectedCard: (state, action) => {
            state.selectedCard = action.payload;
        },
        updateSavedJob: (state, action) => {
            const { index, saved } = action.payload;
           
            if (state.selectedCard?.save_jobs) {
                state.selectedCard.save_jobs = state.selectedCard.save_jobs.map((job, idx) => 
                    idx === index ? { ...job, SAVED: saved } : job
                );
            }
            console.log("index",state.selectedCard?.save_jobs)
        }
    },
});

export const { setSelectedCard,updateSavedJob  } = selectedJobCardSlice.actions;
export default selectedJobCardSlice.reducer;
